export default __webpack_public_path__ + "assets/png/e3dbc3c629f7e2bab63a361d3b6637a0.png";